// =====================================================================
// 1. АВТОМАТИЧНЕ ЗАВАНТАЖЕННЯ ДАНИХ З SHOPIFY METAOBJECTS (GRAPHQL API)
// =====================================================================
window.storesLoadedAPI = false; // Глобальний прапорець для синхронізації з картою

(function() {
    const STOREFRONT_TOKEN = 'ef93d7d9cb760a1a655b14ecac5cd5d1';
    const GRAPHQL_ENDPOINT = '/api/2026-04/graphql.json';

    async function loadAllStores() {
        let allStores = [];
        let hasNextPage = true;
        let cursor = null;
        let loops = 0;

        // Завантажуємо всі магазини (ліміт GraphQL - 250 за раз)
        while (hasNextPage && loops < 10) {
            loops++;
            const query = `
            query getStores($cursor: String) {
                metaobjects(type: "authorized_retail_stores", first: 250, after: $cursor) {
                    pageInfo { hasNextPage endCursor }
                    nodes {
                        store_name: field(key: "store_name") { value }
                        region: field(key: "region") { value }
                        address: field(key: "address") { value }
                        phone: field(key: "phone") { value }
                        link: field(key: "link") { value }
                        latitude: field(key: "latitude") { value }
                        longitude: field(key: "longitude") { value }
                    }
                }
            }`;

            try {
                const response = await fetch(GRAPHQL_ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
                    },
                    body: JSON.stringify({ query, variables: { cursor } })
                });

                const { data, errors } = await response.json();
                if (errors || !data || !data.metaobjects) {
                    console.error('API Error:', errors);
                    break;
                }

                allStores = allStores.concat(data.metaobjects.nodes);
                hasNextPage = data.metaobjects.pageInfo.hasNextPage;
                cursor = data.metaobjects.pageInfo.endCursor;
            } catch (err) {
                console.error('Помилка завантаження магазинів з API:', err);
                break;
            }
        }

        // =========================================================
        // ДОДАНО: Сортування масиву магазинів (Цифри -> Eng -> Укр)
        // =========================================================
        // =========================================================
        // ДОДАНО: Сортування масиву магазинів (1. Цифри -> 2. Eng -> 3. Укр)
        // =========================================================
        allStores.sort((a, b) => {
            // ВАЖЛИВО: Правильне звернення до поля store_name.value
            const nameA = (a.store_name?.value || "").trim();
            const nameB = (b.store_name?.value || "").trim();

            const getPriority = (str) => {
                const match = str.match(/[a-zA-Zа-яА-ЯіїєґІЇЄҐ0-9]/);
                if (!match) return 4;
                
                const char = match[0].toLowerCase();
                if (/[0-9]/.test(char)) return 1;
                if (/[a-z]/.test(char)) return 2;
                if (/[а-яіїєґ]/.test(char)) return 3;
                return 4;
            };

            const priorityA = getPriority(nameA);
            const priorityB = getPriority(nameB);

            if (priorityA !== priorityB) {
                return priorityA - priorityB; 
            }

            const cleanNameA = nameA.replace(/^[^a-zA-Zа-яА-ЯіїєґІЇЄҐ0-9]+/, '');
            const cleanNameB = nameB.replace(/^[^a-zA-Zа-яА-ЯіїєґІЇЄҐ0-9]+/, '');

            return cleanNameA.localeCompare(cleanNameB, 'uk', { 
                numeric: true, 
                sensitivity: 'base' 
            });
        });
        // =========================================================

        const tbody = document.querySelector('#storelocations .table--adress tbody');
        if (!tbody) return;

        let html = '';
        allStores.forEach((n, i) => {
            let s = {
                name: n.store_name?.value || '',
                region: n.region?.value || '',
                address: n.address?.value || '',
                phone: n.phone?.value || '',
                link: n.link?.value || '',
                lat: n.latitude?.value || '',
                lng: n.longitude?.value || ''
            };
            
            let domain = s.link ? s.link.replace(/https?:\/\/(www\.)?/, '').split('/')[0] : '';
            let mapBtn = (s.lat && s.lng) ? `<span data-lng="${s.lng}" data-lat="${s.lat}" class="view-map">Подивитись на карті</span>` : '';

            html += `<tr data-storelocatorid="${3000 + i}">
                <td data-name="Ім'я">${s.name}</td>
                <td data-name="Область">${s.region}</td>
                <td data-name="Адреса">${s.address}</td>
                <td data-name="Телефон">${s.phone}</td>
                <td data-name="Посилання"><a class="olink" href="${s.link}" target="_blank">${domain}</a></td>
                <td data-name="Дивитися проїзд">${mapBtn}</td>
                <td data-name="Longitude" style="display:none;">${s.lng}</td>
                <td data-name="Latitude" style="display:none;">${s.lat}</td>
            </tr>`;
        });
        
        tbody.innerHTML = html;
        window.storesLoadedAPI = true; // Сповіщаємо, що дані готові
    }

    document.addEventListener('DOMContentLoaded', loadAllStores);
})();

// =====================================================================
// 2. ВАШ ОРИГІНАЛЬНИЙ КОД (Повністю збережений, з дрібними фіксами надійності)
// =====================================================================
$(document).ready(function() {
  $('#city_select').niceSelect();
  $('#region_select').niceSelect();
});
  
function initMap() {
  var where_map_elem = document.getElementById('where-map');
  var map_marker = '//mykite.com.ua/cdn/shop/t/15/assets/map-marker.svg?v=30270251411000439041780511422';
  if(!where_map_elem) return;

  var coordinates = new google.maps.LatLng(49.373812, 29.636763);
  var styledMapType = new google.maps.StyledMapType(
    [{ "featureType": "administrative.country", "elementType": "geometry", "stylers": [{ "visibility": "simplified" }, { "hue": "#ff0000" }] }], { name: 'Styled Map' });
  
  var map = new google.maps.Map(where_map_elem, {
    center: coordinates,
    zoom: 6,
    mapTypeControlOptions: { mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map'] },
    mapCluster: { styles: [{ width: 30, height: 30, className: 'marker-clusterer-orange' }, { width: 40, height: 40, className: 'marker-clusterer-orange' }, { width: 50, height: 50, className: 'marker-clusterer-orange' }] },
  });
  
  var markers = [], marker, infowindow = new google.maps.InfoWindow();

  addTrBackground = function() {
    let table = $('#storelocations .table--adress');
    let shownTr = table.find('tbody tr').filter(function() { return this.style.display !== 'none'; });
    shownTr.each(function(step, el) {
      let curStep = step + 1;
      let odd = (curStep % 2) !== 0;
      if(odd) $(this).addClass('odd');
      else $(this).removeClass('odd');
    });
  };
  
  // НАДІЙНЕ ОЧІКУВАННЯ API
  let waitForLoading = setInterval(function() {
    if(window.storesLoadedAPI === true) {
      clearInterval(waitForLoading);
      let markets = $('#storelocations .table--adress tbody tr');
      if(markets.length) {
        addMarkers(markets);
        addTrBackground();
        createPagination($('#storelocations .table--adress'));
        updateSelectValues('#region_select', getAllRegions());
        updateSelectValues('#city_select', getAllCities());
      }
    }
  }, 250); // Перевіряємо кожні 250мс чи завантажилась таблиця

  function addMarkers(markets) {
    markers = [];
    markets.each(function(market) {
  
      let name = $(this).find('td:nth-child(1)').text();
      let region = $(this).find('td:nth-child(2)').text()?.trim();
      
      // Виправлений парсинг міста (безпечний для складних адрес)
      let addressText = $(this).find('td:nth-child(3)').text();
      let addressParts = addressText.split(',');
      let city = "";
      for (let p of addressParts) {
          if (p.includes('м.') || p.includes('с.') || p.includes('смт.')) {
              let pts = p.split('.');
              city = pts.length > 1 ? pts[1].trim() : pts[0].trim();
              break;
          }
      }
      if(!city && addressParts.length > 0) city = addressParts[0].trim();
      
      let phone = $(this).find('td:nth-child(4)').text();
      let lng = parseFloat($(this).find('td:nth-child(7)').text());
      let lat = parseFloat($(this).find('td:nth-child(8)').text());

      if(!name || !region || !city || isNaN(lat) || isNaN(lng)) return;
    
      marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        category: { region: region, city: city },
        map: map,
        icon: map_marker
      });
      
      google.maps.event.addListener(marker, 'click', (function(marker) {
        return function() {
          let returnedContent = '';
          if(name) returnedContent += `<strong>${name}</strong>`;
          if(phone) returnedContent += `<br />${phone}`;
          if(city || addressText) returnedContent += `<br />`;
          if(city) returnedContent += city;
          if(addressText) {
            if(city) returnedContent += ', ';
            returnedContent += addressText;
          }
          infowindow.setContent(returnedContent);
          infowindow.open(map, marker);
        }
      })(marker));
      markers.push(marker);
    });
  
    new MarkerClusterer(map, markers, {
      imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
    });
    
    map.mapTypes.set('styled_map', styledMapType);
    map.setMapTypeId('styled_map');
  }
  
  filterRegion = function(region) {
    let showAll = false;
    if(markers.length) {
      filterTable(region, false);
      var bounds = new google.maps.LatLngBounds();
      var visibleCount = 0;
      if(region.length !== 0) {
        updateSelectValues('#city_select', getCitiesByRegion(region));
        for(let i = 0; i < markers.length; i++) {
          marker = markers[i];
          if(marker.category.region === region || region.length === 0) {
            marker.setVisible(true);
            bounds.extend(marker.getPosition());
            visibleCount++;
          } else {
            marker.setVisible(false);
          }
        }
      } else {
        showAll = true;
        for(let i = 0; i < markers.length; i++) {
          marker = markers[i];
          if(marker.getPosition()) {
            marker.setVisible(true);
            bounds.extend(marker.getPosition());
            visibleCount++;
          }
        }
      }
      if(visibleCount > 0) map.fitBounds(bounds);
      if(showAll) {
        updateSelectValues('#region_select', getAllRegions());
        updateSelectValues('#city_select', getAllCities());
      }
    }
  }
  
  filterCity = function(city) {
    if(markers.length) {
      filterTable(false, city);
      let cityAndRegionEmpty = false;
      var bounds = new google.maps.LatLngBounds();
      var visibleCount = 0;
      if(city.length === 0) {
        let region = $('#region_select').val();
        if(region && $('#region_select').prop('selectedIndex') !== 0) {
          filterRegion(region);
          return;
        } else {
          cityAndRegionEmpty = true;
        }
      }
      for(let i = 0; i < markers.length; i++) {
        marker = markers[i];
        if(marker.category.city === city || cityAndRegionEmpty) {
          marker.setVisible(true);
          bounds.extend(marker.getPosition());
          visibleCount++;
          if(city.length !== 0) {
            updateSelectValues('#region_select', getRegionByCity(city));
            setSelect('region_select', Object.keys(getRegionByCity(city))[0]);
          }
        } else {
          marker.setVisible(false);
        }
      }
      if(visibleCount > 0) map.fitBounds(bounds);
    }
  }
  
  filterTable = function(region, city) {
    let table = $('#storelocations .table--adress');
    if(region?.length || city?.length) {
      table.show();
      table.find('tbody tr').each(function() {
        let curRegion = $(this).find('td:nth-child(2)').text().trim();
        
        let addressText = $(this).find('td:nth-child(3)').text();
        let addressParts = addressText.split(',');
        let curCity = "";
        for (let p of addressParts) {
            if (p.includes('м.') || p.includes('с.') || p.includes('смт.')) {
                let pts = p.split('.');
                curCity = pts.length > 1 ? pts[1].trim() : pts[0].trim();
                break;
            }
        }
        if(!curCity && addressParts.length > 0) curCity = addressParts[0].trim();
        
        if(city?.length) {
          if(curCity == city) $(this).css('display', 'table-row');
          else $(this).hide();
        } else if(region?.length) {
           if(region == curRegion) $(this).css('display', 'table-row');
           else $(this).hide();
        }
      });
      addTrBackground();
      createPagination(table);
    } else {
      table.show();
      table.find('tbody tr').css('display', 'table-row');
      addTrBackground();
      createPagination(table);
    }
  }

  createPagination = function(table) {
    // Враховуємо тільки ті, що не сховані фільтром (display: none від jQuery)
    let shownTr = table.find('tbody tr').filter(function() { return this.style.display !== 'none'; });
    
    if(shownTr.length > 30) {
      let paginationEl = $('#storelocations .pagin');
      if(paginationEl.length) paginationEl.remove();
      
      paginationEl = '<div class="pagin container"></div>';
      $('#storelocations .table--adress').after(paginationEl);
      paginationEl = $('#storelocations .pagin');

      let additionalPaginPage = 0;
      if((shownTr.length % 30) != 0) additionalPaginPage = 1;
      let paginCount = parseInt(shownTr.length / 30 + additionalPaginPage);
      for(let i = 0; i < paginCount; i++) {
        if(i == 0) paginationEl.append('<div class="page-link active" data-pagin="1">'+(i + 1)+'</div>');
        else if(i < 9) paginationEl.append('<div class="page-link" data-pagin="'+(i + 1)+'">'+(i + 1)+'</div>');
      }
      paginationEl.append('<div class="right" data-pagin="2">➝</div>');
      if(paginCount > 9) paginationEl.append('<div class="end" data-pagin="'+paginCount+'">⇥</div>');
    
      shownTr.each(function(step, el) {
        if(step >= 30) $(this).addClass('pagin-hide');
        else $(this).removeClass('pagin-hide');
      });

      let paginLinks = '.left, .right, .page-link, .start, .end';
      paginationEl.off('click').on('click', paginLinks, function() {
        let curPagin = $(this).data('pagin');
        let totalPaginAdded = 0;
        
        paginationEl.find(paginLinks).remove();
        paginationEl.append('<div class="page-link active" data-pagin="'+curPagin+'">'+curPagin+'</div>');
        for(let i = (curPagin - 1); i > 0; i--) {
          if(totalPaginAdded < 4) {
            paginationEl.prepend('<div class="page-link" data-pagin="'+i+'">'+i+'</div>');
            totalPaginAdded++;
          } else break;
        }
        for(let i = (curPagin + 1); i <= paginCount; i++) {
          if(totalPaginAdded < 8) {
            paginationEl.append('<div class="page-link" data-pagin="'+i+'">'+i+'</div>');
            totalPaginAdded++;
          } else break;
        }
        if(curPagin > 1) {
          paginationEl.prepend('<div class="left" data-pagin="1">➝</div>');
          paginationEl.prepend('<div class="start" data-pagin="1">⇤</div>');
        }
        if(curPagin < paginCount) {
          paginationEl.append('<div class="right" data-pagin="'+(curPagin + 1)+'">➝</div>');
          paginationEl.append('<div class="end" data-pagin="'+paginCount+'">⇥</div>');
        }
        if(curPagin == shownTr.length) {
          paginationEl.find('.right').remove();
          paginationEl.find('.end').remove();
        }

        shownTr.removeClass('pagin-hide');
        for(let i = 0; i < shownTr.length; i++) {
          if(i >= (curPagin * 30) || i < (curPagin * 30 - 30)) shownTr.eq(i).addClass('pagin-hide');
        }
        
        let headerHeight = 0;
        let headerEl = $('.shopify-section-main-header header[data-header-sticky]');
        if(headerEl.length) headerHeight = headerEl.height();
        $([document.documentElement, document.body]).animate({
          scrollTop: (table.offset().top - headerHeight - 5)
        }, 1000);
      });
      
    } else {
      let paginationEl = $('#storelocations .pagin');
      if(paginationEl.length) paginationEl.remove();
      shownTr.removeClass('pagin-hide');
    }
  }
  
  showMarker = function(latLng) {
    if(markers.length) {
      var bounds = new google.maps.LatLngBounds();
      bounds.extend(latLng);
      map.fitBounds(bounds);
      map.setZoom(15);
      setTimeout(() => {
        document.querySelector('.tabs-body').scrollIntoView({ block: "start", behavior: "smooth" });
      }, 100)
    }
  }
  
  updateSelectValues = function(element, selectValues) {
    let placeholder = $(element).find('option:first').text();
    $(element).empty().append($("<option></option>").attr("value", "").text(placeholder));
    $.each(selectValues, function(key, value) {
      $(element).append($("<option></option>").attr("value", key).text(value));
    });
    $(element).niceSelect('update');
  }
  
  getAllCities = function() {
    const cities = {}
    markers.forEach(key => { cities[key.category.city] = key.category.city; })
    return cities;
  }
  
  getRegionByCity = function(city) {
    const result = markers.filter(r => r.category.city === city)[0]?.category;
    return result ? { [result.region]: result.region } : {};
  }
  
  getAllRegions = function() {
    const regions = {}
    markers.forEach(key => { regions[key.category.region] = key.category.region; })
    return regions;
  }
  
  getCitiesByRegion = function(region) {
    const cities = {}
    markers.filter(r => r.category.region === region).forEach(i => { cities[i.category.city] = i.category.city; });
    return cities;
  }
  
  setSelect = function(select, value) {
    let options = document.getElementById(select).options;
    for(let i=0; i<options.length; i++) {
        if(options[i].value == value) { options[i].selected = true; break; }
    }
    $(`#${select}`).niceSelect('update');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  let viewed = localStorage.getItem('viewedStores') || [];
  
  $('body').on('click', '.view-map', function(e) {
    let el = this;
    if(!Array.isArray(viewed)) viewed = viewed.split(',');

    viewed.push(el.closest('tr').dataset.storelocatorid);
    el.closest('tr').classList.add('viewed');

    const latLng = {
      lat: parseFloat(el.getAttribute('data-lat')),
      lng: parseFloat(el.getAttribute('data-lng'))
    }
    if(typeof showMarker === 'function') showMarker(latLng);
    localStorage.setItem('viewedStores', viewed);
    e.preventDefault();
  });
  
  // Коли таблиця завантажилась (CustomEvent), проставляємо переглянуті магазини
  window.addEventListener('storesLoadedAPI', function() {
    if(localStorage.getItem('viewedStores')) {
      let $stores = document.querySelectorAll('#storelocations tr');
      $stores.forEach(store => {
        if(localStorage.getItem('viewedStores').includes(store.dataset.storelocatorid)) {
          store.classList.add('viewed');
        }
      })
    }
    if(typeof replaceHLink === 'function') replaceHLink();
  });

  $('#storelocations').delegate('.e-pagination a', 'click', function(e) {
    e.preventDefault();
    $('#storelocations').fadeOut('slow').fadeIn('slow');
    if(typeof replaceHLink === 'function') replaceHLink();
  });
  
  // ФІЛЬТРИ: обробка подій "change"
  $('#region_select, #city_select').on('change', function() {
    var isPlaceholder = ($(this).prop('selectedIndex') === 0);
    var selectedFilter = isPlaceholder ? "" : $(this).find(':selected').text().trim();
    
    if($(this).attr('id') === 'region_select') {
      if(typeof filterRegion !== 'undefined') filterRegion(selectedFilter);
    }
    if($(this).attr('id') === 'city_select') {
      if(typeof filterCity !== 'undefined') filterCity(selectedFilter);
    }
  });
});